import { render, staticRenderFns } from "./workLoadReport.vue?vue&type=template&id=6cc7ac0a&scoped=true"
import script from "./workLoadReport.vue?vue&type=script&lang=js"
export * from "./workLoadReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc7ac0a",
  null
  
)

export default component.exports